/**
 * RevWorks — Homepage Ultracoat x RevWorks section: Ceramic Protection
 * carousel (sections/detailing.liquid).
 *
 * One synchronised photo + info-panel slide at a time, native horizontal
 * scroll-snap rather than a transform slider — same reasoning already
 * established by sections/rw-page-studio-services.liquid's own carousel
 * (touch swipe then works for free, no custom drag math). This is a
 * separate, self-contained script rather than a shared dependency, so it
 * can never affect the unrelated Detailing Services page carousels
 * (assets/rw-detailing-carousel.js) or vice versa.
 *
 * Unlike that page's own multi-card "peek" carousels, this is a single
 * full-width slide at a time with no wrap-around: prev/next disable at
 * the first/last package rather than looping.
 */
(function () {
  var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  initAll(document);

  function initAll(scope) {
    var roots = scope.querySelectorAll('[data-rw-ceramic-carousel]');
    roots.forEach(function (root) {
      if (root.hasAttribute('data-rw-ceramic-inited')) return;
      root.setAttribute('data-rw-ceramic-inited', '');
      initCarousel(root);
    });
  }

  function initCarousel(root) {
    var viewport = root.querySelector('[data-rw-ceramic-viewport]');
    var track = root.querySelector('[data-rw-ceramic-track]');
    if (!viewport || !track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-rw-ceramic-slide]'));
    if (!slides.length) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-rw-ceramic-dot]'));
    var prevButtons = Array.prototype.slice.call(track.querySelectorAll('[data-rw-ceramic-prev]'));
    var nextButtons = Array.prototype.slice.call(track.querySelectorAll('[data-rw-ceramic-next]'));

    function currentIndex() {
      var width = viewport.clientWidth || 1;
      return Math.round(viewport.scrollLeft / width);
    }

    function setActive(index) {
      dots.forEach(function (dot, i) {
        var isActive = i === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function updateEnds(index) {
      prevButtons.forEach(function (btn) {
        btn.disabled = index <= 0;
      });
      nextButtons.forEach(function (btn) {
        btn.disabled = index >= slides.length - 1;
      });
    }

    function goTo(index) {
      var target = Math.max(0, Math.min(slides.length - 1, index));
      viewport.scrollTo({
        left: target * viewport.clientWidth,
        behavior: reduceMotionQuery.matches ? 'auto' : 'smooth'
      });
      setActive(target);
      updateEnds(target);
    }

    prevButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { goTo(currentIndex() - 1); });
    });
    nextButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { goTo(currentIndex() + 1); });
    });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    viewport.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(currentIndex() + 1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(currentIndex() - 1);
      }
    });

    // Scroll-snap means swiping or trackpad scrolling can move the
    // viewport without goTo() ever running — this keeps the dots and
    // the prev/next disabled state in sync with wherever the user has
    // actually landed, not just where the script last sent them.
    var ticking = false;
    viewport.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var index = currentIndex();
        setActive(index);
        updateEnds(index);
        ticking = false;
      });
    }, { passive: true });

    // Keeps the viewport aligned on a slide boundary after a resize
    // (e.g. rotation) — scroll-snap only re-snaps on the next user
    // scroll gesture, not automatically when clientWidth itself changes.
    if (window.ResizeObserver) {
      var resizeObserver = new ResizeObserver(function () {
        viewport.scrollTo({ left: currentIndex() * viewport.clientWidth, behavior: 'auto' });
      });
      resizeObserver.observe(viewport);
    }

    setActive(0);
    updateEnds(0);
  }
})();
